import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
let PiHomeMmapScreenPile = class PiHomeMmapScreenPile extends Vue {
    constructor() {
        super(...arguments);
        this.poptipVisible = false;
        this.all = false;
        this.deviceTypeList = [
            { itemKey: "2", itemValue: i18n.t("homeMap.ac") },
            { itemKey: "3", itemValue: i18n.t("homeMap.dc") },
        ];
        this.nameText = "";
        this.formInline = {
            deviceTypeList: [],
        };
    }
    /**
     * 重置
     */
    resetting() {
        this.formInline.deviceTypeList = [];
        this.nameText = "";
    }
    /**
     * 全选
     */
    cllChange(val) {
        if (!val) {
            this.resetting();
        }
        else {
            this.formInline.deviceTypeList = this.deviceTypeList.map((item) => {
                return item.itemKey;
            });
        }
    }
    /**
     * 返回数据
     */
    retureData() {
        this.poptipVisible = false;
        this.nameText = this.forCityName(this.deviceTypeList, this.formInline.deviceTypeList);
        this.$emit("change", {
            ...this.formInline,
        });
    }
    /**
     * 找出名称
     */
    forCityName(list, itemKey) {
        let name = [];
        list.map((item) => {
            if (itemKey.indexOf(item.itemKey) != -1) {
                name.push(item.itemValue);
            }
        });
        return name.join("/");
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeMmapScreenPile.prototype, "searchName", void 0);
PiHomeMmapScreenPile = __decorate([
    Component({
        components: {},
    })
], PiHomeMmapScreenPile);
export default PiHomeMmapScreenPile;
